import type { LogErrorBeforeSend } from '@zg-rentals/log-error';

// The PerimeterX bootstrap is served from /<pxAppId>/init.js and its failures reach logError but
// aren't ours to fix. The filename comes from the global error handler's context.
const PERIMETERX_FILENAME = /\/[A-Za-z0-9]{6,12}\/init\.js$|perimeterx|px-cloud/;

// A logError beforeSend that discards PerimeterX script errors so they are never reported.
export const discardThirdPartyErrors: LogErrorBeforeSend = ({ context }) => {
  const filename = typeof context.filename === 'string' ? context.filename : '';

  if (PERIMETERX_FILENAME.test(filename)) {
    return false;
  }
};
